const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

export function resolveApiUrl(): string {
  const fromEnv = (window as any)?.env?.API_URL;
  if (fromEnv) return fromEnv;
  return LOCAL_HOSTS.has(window.location.hostname)
    ? 'http://localhost:8080'
    : `${window.location.origin}/api`;
}

export function resolveRecaptchaSiteKey(): string {
  return (window as any)?.env?.RECAPTCHA_SITE_KEY ?? '';
}
